import { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "@/components/ui/sonner";
import { Mail } from "lucide-react";

export default function Contact() {
  const { user } = useAuth();
  const [form, setForm] = useState({ name: user?.name || "", email: user?.email || "", subject: "", message: "" });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", form);
      setSent(true);
    } catch {
      toast.error("Could not send message, please try again");
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid="contact-page">
      <Navbar />
      <section className="bg-slate-950 min-h-[70vh] py-16 sm:py-20 px-6">
        <div className="max-w-xl mx-auto">
          <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-indigo-600 to-cyan-500 flex items-center justify-center mb-6">
            <Mail className="h-6 w-6 text-white" />
          </div>
          <h1 className="font-heading text-2xl sm:text-3xl font-bold text-white mb-3">Contact Us</h1>
          <p className="text-slate-400 mb-10">
            Have a question about CareerStudy360? Send us a message and our team will get back to you.
          </p>

          {sent ? (
            <div className="rounded-2xl border border-emerald-500/30 bg-emerald-500/10 p-8 text-center" data-testid="contact-success-message">
              <p className="text-emerald-300 font-medium">Thanks — your message has been sent. We'll get back to you soon.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
              <div>
                <Label className="text-slate-300">Name</Label>
                <Input data-testid="contact-name-input" required value={form.name} onChange={(e) => update("name", e.target.value)} className="bg-slate-900 border-slate-700 text-white" />
              </div>
              <div>
                <Label className="text-slate-300">Email</Label>
                <Input type="email" data-testid="contact-email-input" required value={form.email} onChange={(e) => update("email", e.target.value)} className="bg-slate-900 border-slate-700 text-white" />
              </div>
              <div>
                <Label className="text-slate-300">Subject</Label>
                <Input data-testid="contact-subject-input" required value={form.subject} onChange={(e) => update("subject", e.target.value)} className="bg-slate-900 border-slate-700 text-white" />
              </div>
              <div>
                <Label className="text-slate-300">Message</Label>
                <Textarea data-testid="contact-message-input" required rows={5} value={form.message} onChange={(e) => update("message", e.target.value)} className="bg-slate-900 border-slate-700 text-white" />
              </div>
              <Button data-testid="contact-submit-button" disabled={sending} type="submit" className="w-full h-11 rounded-xl bg-indigo-600 hover:bg-indigo-700">
                Send Message
              </Button>
            </form>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
}
